import { render, staticRenderFns } from "./DashboardsBINavegantes.vue?vue&type=template&id=08489e31&scoped=true"
import script from "./DashboardsBINavegantes.vue?vue&type=script&lang=js"
export * from "./DashboardsBINavegantes.vue?vue&type=script&lang=js"
import style0 from "./DashboardsBINavegantes.vue?vue&type=style&index=0&id=08489e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08489e31",
  null
  
)

export default component.exports